import * as settings from '../settings';
import React, { Component } from 'react';
import { Modal, Button } from 'react-bootstrap';

class LandingModal extends Component {
  constructor(props) {
    super(props);

    this.state = {
      show: props.show,
    }

    this.onHide = this.onHide.bind(this);
  }

  onHide() {
    this.setState({show: false});
  }

  render() {
    return (
      <Modal show={this.state.show} centered onHide={this.onHide}>
        <Modal.Header closeButton>
          <Modal.Title>Lokalizator GPS</Modal.Title>
        </Modal.Header>
        <a target="_blank" href={settings.TK305_ALLEGRO_URL}><img src="/static/ogimage2.jpg" alt="" style={{width: '100%'}}/></a>
        <Modal.Footer>
          <a className="btn btn-primary" style={{color: '#fff'}} href={settings.TK305_ALLEGRO_URL} target="_blank"><span className="fa fa-shopping-cart"></span> Kup na Allegro</a>
          <a className="btn btn-secondary" style={{color: '#fff'}} href={settings.TK305_MANUAL_URL}>Jak to działa <span className="fa fa-question-circle"></span></a>
        </Modal.Footer>
      </Modal>
    )
  }
}

export default LandingModal;
